var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpresas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20V0H15.5556V20H8.88889V16.1111H6.66667V20H0ZM4.44444 2.22222H2.22222V4.44444H4.44444V2.22222ZM6.66667 2.22222H8.88889V4.44444H6.66667V2.22222ZM13.3333 2.22222H11.1111V4.44444H13.3333V2.22222ZM2.22222 6.66667H4.44444V8.88889H2.22222V6.66667ZM8.88889 6.66667H6.66667V8.88889H8.88889V6.66667ZM11.1111 6.66667H13.3333V8.88889H11.1111V6.66667ZM4.44444 11.1111H2.22222V13.3333H4.44444V11.1111ZM6.66667 11.1111H8.88889V13.3333H6.66667V11.1111ZM13.3333 11.1111H11.1111V13.3333H13.3333V11.1111ZM2.22222 15.5556H4.44444V17.7778H2.22222V15.5556ZM13.3333 15.5556H11.1111V17.7778H13.3333V15.5556Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresas);
export default __webpack_public_path__ + "static/media/empresas.d936d3bd33f51d02d126e66356ce11f0.svg";
export { ForwardRef as ReactComponent };